import React, { useState, useEffect, useCallback, useMemo } from "react";
import Helmet from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { USER } from "common/viewContent";
import * as Path from "routes/Path/index";
import {
  getUsers,
  updateUser,
  AddUser,
  updateUserStatus,
  exportUsersList,
} from "store/actions";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import AddUserModal from "components/Modals/AddUser";
import FormikForm from "components/shared/FormikForm";
import DateRangeFilter from "components/DateRangePicker/DateRangePicker";
import moment from "moment";
import slice from "store/user/slice";
import { Card, CardBody, CardHeader, Col, Row } from "react-bootstrap";
import usePermission from "hooks/usePermission";
import PermissionGate from "components/PermissionGate";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search using first name, last name, email...",
  },
  {
    name: "datepicker",
    type: "datepicker",
    label: "",
    placeholder: "",
  },
  {
    name: "status",
    type: "select",
    label: "",
    placeholder: "Select status",
    options: [
      { value: "active", label: "Active" },
      { value: "blocked", label: "Blocked" },
    ],
  },
];
const initialValuesForFilter = {
  search: "",
  status: "",
};

const List = () => {
  const dispatch = useDispatch();
  const { users, loading, totalCount, totalUsers, liveUsers } = useSelector(
    (state) => state.Users,
  );

  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);

  const [showPicker, setShowPicker] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "createdAt",
    search: "",
    status: "",
    startDate: null,
    endDate: null,
  });

  const { hasPermission } = usePermission();
  const permissions = useMemo(() => ({
    add: false,
    edit: hasPermission("edit_users"),
    delete: false,
  }), [hasPermission]);

  useEffect(() => {
    return () => dispatch(slice.actions.clearUsersList());
  }, []);

  useEffect(() => {
    getApiData(filter);
  }, [filter]);

  useEffect(() => {
    setcolumns(
      Columns({
        handleUserStatus,
        handleEditHandler,
        permissions,
      }),
    );
  }, [permissions.edit]);

  async function getApiData(query) {
    try {
      dispatch(getUsers({ data: query }));
    } catch (error) { }
  }

  const handleUserStatus = (id, status) => {
    try {
      const callback = (err, res) => {
        if (err) return;

        getApiData(filter);
      };

      dispatch(
        updateUserStatus({
          data: { _id: id, status: status },
          callback,
        }),
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const onClickExport = () => {
    dispatch(
      exportUsersList({
        data: {
          startDate: filter.startDate,
          endDate: filter.endDate,
        },
      }),
    );
  };

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "date_created_utc",
      search: info.search,
      status: info.status,
    });
  };
  const navigate = useNavigate();
  const handleEditHandler = (info) => {
    navigate(`/admin/users/view/${info?._id}`);
  };
  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
    setFilter((prevFilter) => ({
      ...prevFilter,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
    setShowPicker(false);
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={USER.CURRENT_MODULE} />

      <section className="section">
        <div className="section-header">
          <h1>{USER.CURRENT_MODULE}</h1>

          {/* <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{USER.CURRENT_MODULE} </div>
          </div> */}
        </div>
        <Row>
          <Col lg="3" md="4" sm="6" className="my-2">
            <Card className="my-2">
              <CardHeader>Total Users</CardHeader>
              <CardBody className="spinner-content">{totalUsers}</CardBody>
            </Card>
          </Col>
          <Col lg="3" md="4" sm="6" className="my-2">
            <Card className="my-2">
              <CardHeader>Live Users</CardHeader>
              <CardBody className="spinner-content">{liveUsers}</CardBody>
            </Card>
          </Col>
        </Row>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{USER.TOP_CONTENT}</h2>
                </div>
              </div>
              <PermissionGate permission="exports_users">
                <div className="col-6">
                  <div className="card-header d-flex justify-content-end align-items-center">
                    <button
                      className="btn btn-primary"
                      onClick={() => onClickExport()}
                    >
                      Export
                    </button>
                  </div>
                </div>
              </PermissionGate>
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                    dateRange={filter}
                    showPicker={showPicker}
                    setShowPicker={setShowPicker}
                    handleSelect={handleSelect}
                  />
                </div>
              </div>
            </div>
          </div>
          {users?.length > 0 && (
            <Table
              data={users}
              columns={columns}
              setFilter={setFilter}
              total={totalCount}
              filter={filter}
              toggleConfirmModal={handleUserStatus}
            />
          )}
          {!loading && users?.user?.length === 0 && (
            <p style={{ textAlign: "center" }}>No User Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
